import reducer from './reducer'

import * as entityTypesOperations from './operations'
import * as entityTypesSelectors from './selectors'

export { entityTypesOperations, entityTypesSelectors }

export default reducer
